import React from "react";
import {usePlayerContext} from "../../context/PlayerContext";
import {useEventContext} from "../../context/EventContext";
import moment from "moment";
import { useStreamContext } from "../../context/StreamContext";

export default () => {
    const {event} = useEventContext();
    const {streams} = useStreamContext();
    const {
        stream,
        episode,
        currentEpisode,
        currentTime,
        duration,
        setStream,
    } = usePlayerContext();

    return (
        <pre>
            <div>stream: {stream?.id || 'null'}</div>
            <div>episode: {episode?.id || 'null'}</div>
            <div>currentEpisode: {currentEpisode?.id || 'null'}</div>
            <div>currentTime: {currentTime} / {duration}</div>
            {streams.map((stream) => (
                <div key={stream.id} style={{display: 'flex'}}>
                    <button onClick={() => setStream(stream)}>{stream.description_ru}</button>
                    {stream.episode.map((episode) => (
                        <button
                            key={episode.id}
                            onClick={() => setStream(stream, episode)}
                            style={{backgroundColor: currentEpisode === episode ? 'red' : ''}}
                        >{episode.name_ru} ({moment.unix(episode.timeStart).format('HH:mm')} - {moment.unix(episode.timeStop).format('HH:mm, DD-MM')})</button>
                    ))}
                </div>
            ))}
        </pre>
    );
}
